import { Dices } from "lucide-react";
import { cn } from "@/lib/utils";

interface LogoProps {
  className?: string;
  size?: "sm" | "md" | "lg";
  /** Render only the Dices mark (no wordmark). Useful for collapsed sidebars. */
  markOnly?: boolean;
}

/**
 * BONUSROLL.NET wordmark.
 *
 *   [▣ Dices]  BONUSROLL.NET
 *
 *  - Lucide Dices icon inside a Melli-textured badge (matches the
 *    statusbar texture used elsewhere in the UI: subtle vertical
 *    gradient + 1px bright top edge + sharp 3px radius).
 *  - Wordmark is always uppercase. "BONUSROLL" gets a metallic-light
 *    Melli sheen, ".NET" gets the same treatment in accent gold so the
 *    URL reads as a single unit but the TLD is visually emphasized.
 */
export function Logo({ className, size = "md", markOnly = false }: LogoProps) {
  const fontSize =
    size === "sm" ? "text-sm" : size === "lg" ? "text-2xl" : "text-base";
  const iconPx = size === "sm" ? 14 : size === "lg" ? 22 : 18;
  const padPx = size === "sm" ? 4 : size === "lg" ? 7 : 5;

  return (
    <span
      className={cn(
        "inline-flex items-center gap-2.5 font-display font-semibold tracking-[0.04em] leading-none whitespace-nowrap",
        fontSize,
        className,
      )}
    >
      <span
        className="melli-mark inline-flex items-center justify-center"
        style={{ padding: padPx }}
        aria-hidden="true"
      >
        <Dices
          size={iconPx}
          strokeWidth={2.25}
          className="text-accent-bright relative z-10"
        />
      </span>

      {!markOnly && (
        <span className="leading-none uppercase">
          <span className="melli-text">BONUSROLL</span>
          <span className="melli-text-accent">.NET</span>
        </span>
      )}
    </span>
  );
}
